export function getIcon(state: string | boolean): string {
  switch (state) {
    case true:
      return 'far fa-check-square'
    case 'indeterminate':
      return 'far fa-minus-square'
    default:
      return 'far fa-square'
  }
}
